/**
 * Markering van de zinnen die uit JP's lijsten komen (Brain grote-ronde/75 keuze
 * 9): de goedgekeurde beloftezinnen uit het overdrachtsblok krijgen in de editor
 * een lijntje. Alleen een decoratie: de HTML die verstuurd wordt verandert niet.
 * Past JP de zin aan, dan valt de markering weg; dat is precies het signaal dat
 * het geen lijstzin meer is.
 */
import { Extension } from "@tiptap/core";
import type { Node as PmNode } from "@tiptap/pm/model";
import { Plugin, PluginKey } from "@tiptap/pm/state";
import { Decoration, DecorationSet } from "@tiptap/pm/view";

export const MARKEER_SLEUTEL = new PluginKey<DecorationSet>("m7Markeer");

/** Platte tekst van één tekstblok, met per teken zijn positie in het document. */
function blokTekst(node: PmNode, pos: number): { tekst: string; plek: number[] } {
  let tekst = "";
  const plek: number[] = [];
  node.forEach((kind, offset) => {
    const begin = pos + 1 + offset;
    if (kind.isText && kind.text) {
      for (let i = 0; i < kind.text.length; i += 1) {
        tekst += kind.text[i];
        plek.push(begin + i);
      }
    } else {
      tekst += "\n";
      plek.push(begin);
    }
  });
  return { tekst, plek };
}

export function markeerDecoraties(doc: PmNode, zinnen: readonly string[]): DecorationSet {
  const schoon = zinnen.map((z) => z.trim()).filter(Boolean);
  if (!schoon.length) return DecorationSet.empty;
  const deco: Decoration[] = [];
  doc.descendants((node, pos) => {
    if (!node.isTextblock) return true;
    const { tekst, plek } = blokTekst(node, pos);
    for (const zin of schoon) {
      let van = tekst.indexOf(zin);
      while (van >= 0) {
        const tot = van + zin.length - 1;
        deco.push(
          Decoration.inline(plek[van], plek[tot] + 1, {
            class: "m7-lijstzin",
            title: "Zin uit de lijst van JP",
          }),
        );
        van = tekst.indexOf(zin, van + zin.length);
      }
    }
    return false;
  });
  return DecorationSet.create(doc, deco);
}

export interface MarkeerOpslag {
  zinnen: readonly string[];
}

export const Markeer = Extension.create<Record<string, never>, MarkeerOpslag>({
  name: "m7Markeer",
  addStorage() {
    return { zinnen: [] };
  },
  addProseMirrorPlugins() {
    const opslag = this.storage;
    return [
      new Plugin<DecorationSet>({
        key: MARKEER_SLEUTEL,
        state: {
          init: (_, state) => markeerDecoraties(state.doc, opslag.zinnen),
          apply: (tr, oud) =>
            tr.docChanged || tr.getMeta(MARKEER_SLEUTEL)
              ? markeerDecoraties(tr.doc, opslag.zinnen)
              : oud,
        },
        props: {
          decorations: (state) => MARKEER_SLEUTEL.getState(state),
        },
      }),
    ];
  },
});
